module.exports = __webpack_public_path__ + "static/img/8.26d40a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/8.jpg
// module id = XBXX
// module chunks = 1